import { APIClient } from "api/api_helper";
import { Study_API, VOLUNTEER_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

// ------------------------------------------------------------------
// API CLIENT
// ------------------------------------------------------------------

const api = new APIClient();

// ------------------------------------------------------------------
// Volunteer Attachment API
// ------------------------------------------------------------------

export interface StudyICFSelectAllParams {
  otherid?: number | null;
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;
  volunteerid?: number | null;
  studyid?: number | null;
}

export const volunteerStudyICFInfo = {
  // ------------------------------------------------------------------
  // INSERT
  // ------------------------------------------------------------------
  insertData: (formData: FormData) => {
    const user = GetUserData() as CurrentUser;

    // Append required extra fields
    formData.append("createdby", String(user.userid));

    return api.create(
      Study_API.ICF_API + "Insert",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  },

  // ------------------------------------------------------------------
  // SELECT ALL
  // ------------------------------------------------------------------
  getSelectAllData: ({
    otherid,
    searchText,
    pageNumber = 1,
    pageSize = 10,
    volunteerid,
    studyid,
  }: StudyICFSelectAllParams = {}) => {


    const payload = {
      otherid,
      volunteerid,
      studyid,
      status: "A",
      searchtext: searchText || null,
      currentpage: pageNumber,
      pagesize: pageSize,
    };

    return api.create(
      Study_API.ICF_SELECT + "SelectAll",
      payload
    );
  },
};
